// loaders.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
import { NPM_TAG } from "../npm-tag.js";
let warningIssued = false;
function getVersion() {
    if (!globalThis._loadersgl_?.version) {
        globalThis._loadersgl_ = globalThis._loadersgl_ || {};
        // __VERSION__ is injected by babel-plugin-version-inline
        if (typeof "4.4.2" === 'undefined' && !warningIssued) {
            // eslint-disable-next-line
            console.warn('loaders.gl: The __VERSION__ variable is not injected using babel plugin. Latest unstable workers would be fetched from the CDN.');
            globalThis._loadersgl_.version = NPM_TAG;
            warningIssued = true;
        }
        else {
            globalThis._loadersgl_.version = "4.4.2";
        }
    }
    return globalThis._loadersgl_.version;
}
export const VERSION = getVersion();
//# sourceMappingURL=version.js.map